import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { ConfigurationStatus, ConfigurationType } from '../../../../../domain/consts';
import { PropertyType } from '../../../../../domain/dictionary.model';
import { Offer } from '../../../../../domain/offer.domain';
import {
    InsuredProductProperty,
    PropertyConfiguration,
    PropertyConfigurationStep,
    PropertyFlatElements,
    PropertyHouseElements
} from '../../../../../domain/product.domain';
import { OfferAction } from '../../../store/offer.action';

@Component({
    selector: 'app-property-box',
    templateUrl: './property-box.component.html',
    styleUrls: ['./property-box.component.scss']
})
export class PropertyBoxComponent {

    @Input() offer: Offer;
    @Input() readonly = false;

    constructor(private store: Store, private translateService: TranslateService) {
    }

    get elements() {
        const code = this.configuration.propertyType
            ? this.configuration.propertyType.code
            : PropertyType.HOUSE;
        return code === PropertyType.HOUSE
            ? PropertyHouseElements
            : PropertyFlatElements;
    }

    get insuranceScope() {
        const configuration = this.configuration;
        const result = this.elements
            .map(e => {
                return {label: e.label, available: configuration.elementList[e.type].selected}
            });
        result.push({label: 'OFFER_CONFIG.FLOOD_RISK', available: configuration.floodRisk.selected});
        result.push({label: 'OFFER_CONFIG.OC_PERSONAL', available: configuration.personalLiability.selected});
        return result
            .filter(element => element.available)
            .map(element => this.translateService.instant(element.label))
            .join(', ');
    }

    get product() {
        return this.offer.productList
            .find(p => p.configuration.configurationType === ConfigurationType.PROPERTY) as InsuredProductProperty;
    }

    get productId(): number {
        const product = this.product;
        if (product) {
            return product.id;
        }
        return null;
    }

    get configuration(): PropertyConfiguration {
        return this.offer.productList
            .map(p => p.configuration)
            .find(p => p.configurationType === ConfigurationType.PROPERTY) as PropertyConfiguration;
    }

    get hasFinishedConfiguration() {
        if (!this.configuration) {
            return false;
        }
        return this.configuration.configurationStatus === ConfigurationStatus.COMPLETED;
    }

    get hasErrors() {
        if (!this.configuration) {
            return false;
        }
        return this.configuration.configurationStep === PropertyConfigurationStep.DETAILS
            && this.configuration.configurationStatus === ConfigurationStatus.ERRORS;
    }

    configure() {
        this.store.dispatch(new OfferAction.CreateProductProperty(this.offer.id))
    }

    delete() {
        if (this.productId) {
            this.store.dispatch(new OfferAction.DeleteProduct(this.offer.id, this.productId));
        }
    }

    preview() {
        this.store.dispatch(new OfferAction.ReadonlyProperty(this.product))
    }
}
